import actionTypes from 'SRC/modules/redux/actionTypes'

export const setIsTransitioning = isTransitioning => ({
  type: actionTypes.SET_IS_TRANSITIONING,
  payload: isTransitioning
})
